export const API_BASE = process.env["REACT_APP_API_BASE"] || "http://localhost:4001"
export const DEMO_MODE = process.env["REACT_APP_DEMO_MODE"] && process.env["REACT_APP_DEMO_MODE"].toLowerCase() === "true"